// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"c9f313b1","374":"e217db79","484":"14cb0921","551":"c2ddb01f","869":"b6dda42b","974":"87dcfbc9"}[chunkId] + ".chunk.js";
};